<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">Edit Group Permissions</h3>
    </div>
  </div>
  <div class="row top10">

    <div class="col-sm-4 col-lg-4 vcenter">
      <b>Group:</b> &nbsp;
      <aims-lookup
        name="Group"
        [gridText]="'Select a Group'"
        style="width:50%"
        [values]="groupValues | async"
        [idPropertyName]="'permissionGroupId'"
        [displayPropertyName]="'permissionGroupName'"
        [ngModel]="group"
        (valueChangeObj)="handleGroupChange($event)"
        [columnsInGrid]="groupLookupColumns"
        >
      </aims-lookup>
    </div>
  </div>
  <div class="flex-container" *ngIf="isCloneGroup == false">
    <aims-common-button
      aria-label="Add New Group"
      (click)="handleAddGroup()"
      *ngIf="this.canCreate">
        <mat-icon>add</mat-icon>
        Add
    </aims-common-button>
    <aims-common-button
      aria-label="Edit this Group"
      (click)="handleEditGroup()"
      *ngIf="(group|async) != null && this.canUpdate">
      <mat-icon>mode_edit</mat-icon>
      Edit
    </aims-common-button>
    <aims-common-button
      aria-label="Delete this Group"
      (click)="handleDeleteGroup($event)"
      *ngIf="(group|async) != null && this.canDelete">
      <mat-icon color="warn">delete</mat-icon>
      Delete
    </aims-common-button>
    <aims-common-button
      aria-label="Clone this Group"
      (click)="handleOpenCloneGroup()"
      *ngIf="(group|async) != null && this.canCloneGroup">
      <mat-icon>content_copy</mat-icon>
      Clone
    </aims-common-button>
  </div>

  <div class="row top20" *ngIf="(group|async) != null">
    <div>
      <mat-tab-group mat-align-tabs="start">
        <!-- Permissions Tab-->
        <mat-tab label="Group Permissions" *ngIf="isCloneGroup == false">
            <div class="table-container">
            <form novalidate #permGrid="ngForm" *ngIf="(groupPermissions|async) != null">
              <div>
                  <aims-common-table
                    [dataSource]="groupPermissionsDataSource"
                    [header]="groupPermissionsColumns"
                    [permissions]="permissions"
                    id="GroupPermissions"
                    (rowAdded)="handlePermissionsRowAdd($event)"
                    (rowUpdated)="handlePermissionsRowUpdate($event)"
                    (rowDeleted)="handlePermissionsRowDelete($event)"
                    (rowCancelled)="handlePermissionsRowCancelled($event)"
                    [addRowInitialObject]="addPermissionsRowInitialObject"
                    [stickyHeader]="true"
                    [pageSize]="10"
                  >
                    <!-- Component Name -->
                    <aims-common-table-dynamic-row id="component.component">
                      <ng-template viewMode let-element>
                        {{element.component?.component}}
                      </ng-template>
                      <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                          <aims-lookup
                            [ngClass]="{'ng-invalid': dynamicControl?.invalid}"
                            name="component"
                            [gridText]="'Select a Component'"
                            id="componentNameLookup"
                            [values]="components | async"
                            [idPropertyName]="'componentId'"
                            [displayPropertyName]="'component'"
                            [columnsInGrid]="componentNameLookupColumns"
                            [altDisplay]="dynamicControl?.value"
                            (valueChangeObj)="handlePermissionsAimsLookupChange($event, element, dynamicControl)"
                          >
                          </aims-lookup>
                      </ng-template>
                    </aims-common-table-dynamic-row>

                    <!-- Component Description -->
                    <aims-common-table-dynamic-row id="component.description">
                      <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                        <quill-view [content]="dynamicControl?.value" >
                        </quill-view>
                      </ng-template>
                    </aims-common-table-dynamic-row>

                    <!--Parent Component Name -->
                    <aims-common-table-dynamic-row id="component.parentComponent.component" >
                      <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                        {{dynamicControl?.value}}
                      </ng-template>
                    </aims-common-table-dynamic-row>
                    <!--Create-->
                    <aims-common-table-dynamic-row id="create">
                      <ng-template viewMode let-element>
                        <div class="text-center">
                          <ng-container *ngIf="element.create === true">
                            <img src="{{imgSrc}}/check.png" style="width:20px" />
                          </ng-container>
                          <ng-container *ngIf="!element.create">
                            <img src="{{imgSrc}}/X.png" style="width:20px" />
                          </ng-container>
                        </div>
                      </ng-template>
                      <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                        <div class="fullWidth text-center">
                          <mat-checkbox [formControl]="dynamicControl" ></mat-checkbox>
                        </div>
                      </ng-template>
                    </aims-common-table-dynamic-row>

                    <!-- Read -->
                    <aims-common-table-dynamic-row id="read">
                      <ng-template viewMode let-element>
                        <div class="fullWidth text-center">
                          <ng-container *ngIf="element.read">
                            <img src="{{imgSrc}}/check.png" style="width:20px" />
                          </ng-container>
                          <ng-container *ngIf="!element.read">
                            <img src="{{imgSrc}}/X.png" style="width:20px" />
                          </ng-container>
                        </div>
                      </ng-template>
                      <ng-template editMode let-element let-dynamicControl="dynamicControl">
                        <div class="fullWidth text-center">
                          <mat-checkbox [formControl]="dynamicControl" ></mat-checkbox>
                        </div>
                      </ng-template>
                    </aims-common-table-dynamic-row>

                    <!-- Update -->
                    <aims-common-table-dynamic-row id="update">
                      <ng-template viewMode let-element>
                        <div class="fullWidth text-center">
                          <ng-container *ngIf="element.update">
                            <img src="{{imgSrc}}/check.png" style="width:20px" />
                          </ng-container>
                          <ng-container *ngIf="!element.update">
                            <img src="{{imgSrc}}/X.png" style="width:20px" />
                          </ng-container>
                        </div>
                      </ng-template>
                      <ng-template editMode let-element let-dynamicControl="dynamicControl">
                        <div class="fullWidth text-center">
                          <mat-checkbox [formControl]="dynamicControl" ></mat-checkbox>
                        </div>
                      </ng-template>
                    </aims-common-table-dynamic-row>

                    <!-- Delete -->
                    <aims-common-table-dynamic-row id="delete">
                      <ng-template viewMode let-element>
                        <div class="fullWidth text-center">
                          <ng-container *ngIf="element.delete">
                            <img src="{{imgSrc}}/check.png" style="width:20px" />
                          </ng-container>
                          <ng-container *ngIf="!element.delete">
                            <img src="{{imgSrc}}/X.png" style="width:20px" />
                          </ng-container>
                        </div>
                      </ng-template>
                      <ng-template editMode let-element let-dynamicControl="dynamicControl">
                        <div class="fullWidth text-center">
                          <mat-checkbox [formControl]="dynamicControl" ></mat-checkbox>
                        </div>
                      </ng-template>
                    </aims-common-table-dynamic-row>
                  </aims-common-table>
                </div>
              </form>
            </div>
        </mat-tab>

        <!--  Membership Tab -->
        <mat-tab label="Group Membership" *ngIf="isCloneGroup == false">
          <div class="table-container">
            <form novalidate #permGrid="ngForm" *ngIf="(groupMembership|async) != null">
              <div>
                <aims-common-table
                  [dataSource]="groupMembershipDataSource"
                  [header]="groupMembershipColumns"
                  [permissions]="permissions"
                  id="Group Membership"
                  (rowAdded)="handleMembershipRowAdd($event)"
                  (rowUpdated)="handleMembershipRowUpdate($event)"
                  (rowDeleted)="handleMembershipRowDelete($event)"
                  (rowCancelled)="handleMembershipRowCancelled($event)"
                  [addRowInitialObject]="addMembershipRowInitialObject"
                  [stickyHeader]="true"
                  [pageSize]="10"
                >
                  <!-- User Name -->
                  <aims-common-table-dynamic-row id="userName">
                    <ng-template viewMode let-element>
                      {{ element.userName }}
                    </ng-template>
                    <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                        <aims-lookup
                          name="userName"
                          id="userNameLookup"
                          [gridText]="'Select a User'"
                          [values]="activeUsers | async"
                          [idPropertyName]="'userId'"
                          [displayPropertyName]="'userName'"
                          [columnsInGrid]="userLookupColumns"
                          [altDisplay]="dynamicControl?.value"
                          (valueChangeObj)="handleMembershipAimsLookupChange($event, element, dynamicControl)"
                          [ngClass]="{'ng-invalid': dynamicControl?.invalid}"
                        >
                        </aims-lookup>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <!-- Active -->
                  <aims-common-table-dynamic-row id="active">
                    <ng-template viewMode editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                      <div class="text-center">
                        <ng-container *ngIf="element.active === true">
                          <img src="{{imgSrc}}/check.png" style="width:20px" />
                        </ng-container>
                        <ng-container *ngIf="!element.active">
                          <img src="{{imgSrc}}/X.png" style="width:20px" />
                        </ng-container>
                      </div>
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>
              </div>
            </form>
          </div>
        </mat-tab>
        <!-- Cloning Tab-->
        <mat-tab label="Clone Group" *ngIf="isCloneGroup == true">
          <div class="table-container">
            <div class="flex-container end">
              <aims-common-button
                aria-label="Cancel"
                (click)="handleCancelCloneGroup()">
                &nbsp;Cancel
              </aims-common-button>
              <aims-common-button
                aria-label="Clone Group"
                (click)="handleCloneGroup()"
                [disabled]="!cloneGroupForm.valid">
                <mat-icon>content_copy</mat-icon>
                Clone Group
              </aims-common-button>
            </div>
            <form novalidate #permGrid="ngForm" *ngIf="(groupPermissions | async) != null && groupToClone != null" [formGroup]="cloneGroupForm">
              <div class="form" autocomplete="off">
                <mat-form-field appearance="fill" class="form-item">
                  <mat-label>Group Name</mat-label>
                  <input matInput type="text" formControlName="name" name="permissionGroupName" required/>
                  <mat-error *ngIf="cloneGroupForm.controls.name.hasError('required')">Please enter a group name</mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="form-item">
                  <mat-label>Group Description</mat-label>
                  <input matInput type="text" formControlName="description" name="permissionGroupDescription" required>
                  <mat-error *ngIf="cloneGroupForm.controls.description.hasError('required')">Please enter a group description</mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="form-item" *ngIf="this.canCloneGroupToDifferentTenant">
                  <mat-label>Select Tenant</mat-label>
                  <mat-select formControlName="tenantId" name="tenantId" [attr.required]="this.canCloneGroupToDifferentTenant">
                    <mat-option *ngFor="let t of tenants | async" [value]="t.tenantId">
                      <span>
                        {{t.shortName}}
                      </span>
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="cloneGroupForm.controls.tenantId.hasError('required')">Please choose a tenant to clone to</mat-error>
                </mat-form-field>
              </div>
              <h4>Clone these Components</h4>
              <aims-common-table
                id="CloneGroup"
                [dataSource]="groupPermissionsDataSource"
                [header]="cloneGroupPermissionsColumns"
                [permissions]="clonePermissions"
                (selectionClick)="handleCloneGroupRowClick($event)"
                (selectionAllClick)="handleCloneGroupRowClick($event)"
                [stickyHeader]="true"
                [pageSize]="10"
              >
                <!-- Component Name -->
                <aims-common-table-dynamic-row id="component.component">
                  <ng-template viewMode let-element>
                    {{element.component?.component}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <!-- Component Description -->
                <aims-common-table-dynamic-row id="component.description">
                  <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                    <quill-view [content]="dynamicControl.value" >
                    </quill-view>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <!--Parent Component Name -->
                <aims-common-table-dynamic-row id="component.parentComponent.component">
                  <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                    {{element.component?.parentComponent?.component}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <!--Create-->
                <aims-common-table-dynamic-row id="create">
                  <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                    <div class="text-center">
                      <ng-container *ngIf="element.create === true">
                        <img src="{{imgSrc}}/check.png" style="width:20px" />
                      </ng-container>
                      <ng-container *ngIf="!element.create">
                        <img src="{{imgSrc}}/X.png" style="width:20px" />
                      </ng-container>
                    </div>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <!-- Read -->
                <aims-common-table-dynamic-row id="read">
                  <ng-template viewMode let-element>
                    <div class="fullWidth text-center">
                      <ng-container *ngIf="element.read">
                        <img src="{{imgSrc}}/check.png" style="width:20px" />
                      </ng-container>
                      <ng-container *ngIf="!element.read">
                        <img src="{{imgSrc}}/X.png" style="width:20px" />
                      </ng-container>
                    </div>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <!-- Update -->
                <aims-common-table-dynamic-row id="update">
                  <ng-template viewMode let-element>
                    <div class="fullWidth text-center">
                      <ng-container *ngIf="element.update">
                        <img src="{{imgSrc}}/check.png" style="width:20px" />
                      </ng-container>
                      <ng-container *ngIf="!element.update">
                        <img src="{{imgSrc}}/X.png" style="width:20px" />
                      </ng-container>
                    </div>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <!-- Delete -->
                <aims-common-table-dynamic-row id="delete">
                  <ng-template viewMode let-element>
                    <div class="fullWidth text-center">
                      <ng-container *ngIf="element.delete">
                        <img src="{{imgSrc}}/check.png" style="width:20px" />
                      </ng-container>
                      <ng-container *ngIf="!element.delete">
                        <img src="{{imgSrc}}/X.png" style="width:20px" />
                      </ng-container>
                    </div>
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </form>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
